.container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 0.8rem;
  padding: 0.8rem;
  border-radius: 0.4rem;
  background-color: var(--color-grayscale-tuna);
}

/* Doubled class: this overrides BaseBlock, which still injects its own
   styles at runtime. styled(BaseBlock) guaranteed the override won; a
   single class would depend on stylesheet order. */
.block.block {
  min-width: 12rem;
  width: 12rem;
}

.block-text {
  flex: 0 0 auto;
  font-weight: 400;
  font-size: 1.2rem;
  padding: 0.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.header-data-wrapper {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  gap: 0.4rem;
  width: 100%;
  padding-inline-start: 0.4rem;
}
